module.exports = __webpack_public_path__ + "img/mode-01.b0b2e07e.png";